import _test from "ramda/es/test";
import _when from "ramda/es/when";
import _replace from "ramda/es/replace";
import _pipe from "ramda/es/pipe";
export default _pipe(_replace(/[^\d+]/g, ''), _when(_test(/^00[1-9]\d{8,14}$/), _replace(/^00/, '+')), _when(_test(/^0\d{8,9}$/), _replace(/^0/, '+32')));